// Lib imports
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { withStyles, IconButton, Typography, Tabs, Tab, Box, Badge, Paper, Accordion, AccordionSummary, AccordionDetails, Grid, CircularProgress } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { faExclamationTriangle, faUser, faCalendarAlt } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Custom imports
import { SideBar } from '../../../../../common/components/UI';
import { workplanWarningStyles } from '../../../../styles/warningStyles'
import { scrollIntoView } from '../functions'

const CATEGORY = {
    SKILL_CERTIFICATION: { id: 0, translate: 'skillCertification', subCategories: [{ id: 1, translate: 'missingCertification' }, { id: 2, translate: 'missingSkill' }, { id: 3, translate: 'expiringCertification' }] },
    SCHEDULING_CONFLICT: { id: 1, translate: 'schedulingConflict', subCategories: [{ id: 0, translate: 'overlapInSameWorkplan' }, { id: 4, translate: 'overlapInDifferentWorkplan' }] },
    WORKPLAN_TEMPLATE: { id: 2, translate: 'workplanTemplate', subCategories: [{ id: 5, translate: 'emptyShiftLine' }, {id: 7, translate: 'managerJobAccess'}] },
    ASSIGNMENTS: { id: 3, translate: 'assignments', subCategories: [{ id: 6, translate: 'entryNotFound' }]}
}

// Taken from material ui doc https://material-ui.com/components/tabs/#automatic-scroll-buttons
class TabPanel extends Component {
    render() {
        const { children, value, index, ...other } = this.props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`scrollable-auto-tabpanel-${index}`}
                aria-labelledby={`scrollable-auto-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }
}

class WorkplanWarnings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            currentTab: 0,
            lastClicked: null,
        };
    }

    handleDrawerClose = () => {
        this.setState({ isOpen: false, lastClicked: null })
    }
    handleToggleWarnings = () => {
        this.setState({ isOpen: !this.state.isOpen, lastClicked: null })
    }

    // Taken from material ui https://material-ui.com/components/tabs/#automatic-scroll-buttons
    a11yProps = (index) => {
        return {
            id: `scrollable-force-tab-${index}`,
            'aria-controls': `scrollable-force-tabpanel-${index}`
        };
    }

    handleChangeTab = (event, newValue) => {
        this.setState({
            currentTab: newValue
        })
    };

    handleWarningClick = (id) => {
        this.setState({
            isOpen: false,
            lastClicked: id
        })
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevState.lastClicked !== this.state.lastClicked && this.state.lastClicked) {
            setTimeout(() => {
                scrollIntoView(this.state.lastClicked)
            }, 500) // to bypass rerendering time
        }
    }

    render() {
        const { isOpen, currentTab } = this.state
        const { t, classes, workplanSetting, warnings } = this.props;
        const employeeWarnings = warnings.employeeWarnings ? warnings.employeeWarnings : [];
        const totalWarningCount = employeeWarnings.length;
        
        const skillCertificationWarningCount = employeeWarnings.filter(x => x.category === CATEGORY.SKILL_CERTIFICATION.id).length;
        const scheduleConflictWarningCount = employeeWarnings.filter(x => x.category === CATEGORY.SCHEDULING_CONFLICT.id).length;
        const workplanTemplateWarningCount = employeeWarnings.filter(x => x.category === CATEGORY.WORKPLAN_TEMPLATE.id).length;
        const assignmentWarningCount = employeeWarnings.filter(warning => warning.category === CATEGORY.ASSIGNMENTS.id).length;
        const employeeWarningCount = skillCertificationWarningCount + scheduleConflictWarningCount + assignmentWarningCount;
        const scheduleWarningCount = workplanTemplateWarningCount;

        const renderEmployeeWarningByCategory = (categoryFilter) => { // 0 = Skills and Certif
            const warnings = employeeWarnings.filter(warning => warning.category === categoryFilter.id);
            return <Fragment>
                {
                    categoryFilter.subCategories.map(subCategory => {
                        let filteredWarnings = warnings.filter(warning => warning.subCategory === subCategory.id)
                        return (
                            <Fragment key={`warning-sub-category-${subCategory.id}`}>
                                {
                                    filteredWarnings.length > 0 ?
                                        <Paper variant='outline' square className={classes.subCategoryPaper}>
                                            <Typography variant='h6' className={classes.subCategoryTitle}>{t(`warnings.subCategory.${subCategory.translate}`)}</Typography>
                                            {filteredWarnings.map((warning, index) => {
                                                return (
                                                    <Box 
                                                        key={`warning-box-${warning.message[0]}-${index}`}
                                                        className={classes.employeeBox} 
                                                        onClick={() => this.handleWarningClick(warning.shiftlineId)}
                                                    >
                                                        <Paper variant="outlined">
                                                            <Grid container spacing={1} className={classes.userPaper}>
                                                                {
                                                                    warning.employeeName && (<Grid item xs={12} className={classes.employeeName}>{`${warning.employeeName} (${warning.employeeNumber})`}</Grid>)
                                                                }
                                                                <Grid item xs={12}>
                                                                    {warning.message.map((message, index) => {
                                                                        return (
                                                                            <Grid
                                                                                container
                                                                                key={`warning-message-${index}`}
                                                                            >
                                                                                <Grid item xs={1} className={classes.listItem}>
                                                                                    {index + 1}
                                                                                </Grid>
                                                                                <Grid item xs={11} className={classes.warningMessage}>
                                                                                    {message}
                                                                                </Grid>
                                                                            </Grid>
                                                                        )
                                                                    })}
                                                                </Grid>
                                                            </Grid>
                                                            {/* <div>{`${entry.startDate} - ${entry.endDate}`}</div> */}
                                                        </Paper>
                                                    </Box>
                                                );
                                            })}
                                            {workplanSetting.content.importation != null
                                                && workplanSetting.content.importation.allowSchedulePatternTemplateOverride
                                                && (subCategory.translate === "overlapInDifferentWorkplan" || subCategory.translate === "overlapInSameWorkplan") ? <Typography variant="body2">{t('warnings.overlapMessageWarning')}</Typography> : <></>}
                                        </Paper> : null
                                }
                            </Fragment>
                        )
                    })
                }
            </Fragment>
        }

        return (
            warnings.isLoading ? (
                <CircularProgress className={classes.loadingContainer} size={20} />) :
            <Fragment>
                {
                    totalWarningCount > 0 ? <Fragment>
                        <IconButton className={classes.warningIconButton} onClick={this.handleToggleWarnings} size={'small'}>
                            <Badge invisible={totalWarningCount === 0} badgeContent={totalWarningCount} color="error">
                                <FontAwesomeIcon icon={faExclamationTriangle} className={classes.warningIcon} />
                            </Badge>
                        </IconButton>
                        <SideBar
                            handleDrawerClose={this.handleDrawerClose}
                            open={isOpen}
                            className={classes.sideBar}
                            title={<Typography className={classes.sideBarTitle}>{t('warnings.globalWarningsTitle')}</Typography>}
                        >
                            {/* TODO warning contents */}
                            <Tabs
                                variant="scrollable"
                                scrollButtons="auto"
                                value={currentTab}
                                onChange={this.handleChangeTab}
                                indicatorColor={"primary"}
                            >
                                <Tab 
                                    icon={<FontAwesomeIcon icon={faUser} className={classes.tabIcon} />} 
                                    label={
                                        <span className={classes.tabLabel}>
                                            {`Employees (${employeeWarningCount})`}
                                        </span>} 
                                    {...this.a11yProps(0)} 
                                />
                                <Tab 
                                    icon={<FontAwesomeIcon icon={faCalendarAlt} />} 
                                    label={
                                        <span className={classes.tabLabel}>
                                            {`Schedules (${scheduleWarningCount})`}
                                        </span>} 
                                    {...this.a11yProps(1)}
                                />
                                {/* <Tab icon={<FontAwesomeIcon icon={faChartPie} />} label={`Coverage (${mock.filter\(warning => warning.type === 1).length})`} {...this.a11yProps(2)} disabled /> */}
                            </Tabs>
                            <TabPanel value={currentTab} index={0}>
                                {skillCertificationWarningCount > 0 ?
                                    <Accordion square className={classes.accordion}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="skillsAndCertifications-content"
                                            id="skillsAndCertifications-header"
                                        >
                                            <Typography className={classes.accordionTitle}>{t('warnings.skillsAndCertificationsTitle')}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={classes.accordionDetails}>
                                            {renderEmployeeWarningByCategory(CATEGORY.SKILL_CERTIFICATION)}
                                        </AccordionDetails>
                                    </Accordion> : null
                                }
                                {scheduleConflictWarningCount > 0 ?
                                    <Accordion square className={classes.accordion}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="schedulingConflict-content"
                                            id="schedulingConflict-header"
                                        >
                                            <Typography className={classes.accordionTitle}>{t('warnings.schedulingConflictTitle')}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={classes.accordionDetails}>
                                            {renderEmployeeWarningByCategory(CATEGORY.SCHEDULING_CONFLICT)}
                                        </AccordionDetails>
                                    </Accordion> : null
                                }
                                {
                                    assignmentWarningCount > 0 ?
                                        <Accordion square className={classes.accordion}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="schedulingConflict-content"
                                                id="schedulingConflict-header"
                                            >
                                                <Typography className={classes.accordionTitle}>{t('warnings.assignmentsTitle')}</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className={classes.accordionDetails}>
                                                {renderEmployeeWarningByCategory(CATEGORY.ASSIGNMENTS)}
                                            </AccordionDetails>
                                        </Accordion> : null
                                }
                            </TabPanel>
                            <TabPanel value={currentTab} index={1}>
                                {workplanTemplateWarningCount > 0 ?
                                    <Accordion square className={classes.accordion}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="workplanTemplate-content"
                                            id="workplanTemplate-header"
                                        >
                                            <Typography className={classes.accordionTitle}>{t('warnings.workplanTemplateTitle')}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails className={classes.accordionDetails}>
                                            {renderEmployeeWarningByCategory(CATEGORY.WORKPLAN_TEMPLATE)}
                                        </AccordionDetails>
                                    </Accordion> : null
                                }
                            </TabPanel>
                            {/*<TabPanel value={currentTab} index={2}>
                            </TabPanel> */}
                        </SideBar>
                    </Fragment> : null
                }
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        warnings: state.warnings,
    }
}

export default connect(mapStateToProps)(withStyles(workplanWarningStyles)(translate('workplanManager')(WorkplanWarnings)));